import {observable} from 'mobx';
//config
import config from '../config';

class CocoRobo {
  version(){
    return config.env.version;
  }
}

var cocorobo  = new CocoRobo;

export default cocorobo;



// WEBPACK FOOTER //
// ./src/store/cocorobo.js